﻿<template>
    <attachment
        :attachment="attachment">
        <template #upload-button>
            <div
                v-require-can-edit-library="libraryName"
                class="control horizontal-buttons">
                <b-upload
                    class="file-label"
                    @update:model-value="onUpload">
                    <span class="file-cta">
                        <b-icon
                            class="pr-3"
                            size="is-small"
                            icon="upload" />
                        <span class="file-label">Upload</span>
                    </span>
                </b-upload>
            </div>
        </template>
    </attachment>
</template>

<script>
    import { requireCanEditLibrary } from '@/shared/directives/requirePermission';
    import { uploadAttachmentToLibrary } from '@/shared/helpers/api.ts';
    import Attachment from '@/shared/components/Attachment.vue';

    export default {
        directives: {
            requireCanEditLibrary
        },
        components: {
            Attachment
        },
        props: {
            attachment: {
                type: Object,
                default: () => null
            },
            libraryName: {
                type: String,
                required: true
            }
        },
        emits: [
            'updateAttachment'
        ],
        methods: {
            async onUpload(file) {
                const form = new FormData();
                form.append('file', file);
                await uploadAttachmentToLibrary(this, this.libraryName, form);
                this.$emit('updateAttachment');
            }
        }
    };
</script>

<style scoped>
.horizontal-buttons {
    display: inline-block;
}
</style>
